var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertSvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    height: "70px",
    width: "70px",
    id: "Capa_1",
    viewBox: "15 55 298.25 140.25",
    xmlSpace: "preserve",
    style: {
      transform: "scale(1.)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "alert-icon-siren",
    d: "M232.125,149c0-46.116-37.384-83.5-83.5-83.5s-83.5,37.384-83.5,83.5v83.25h167V149z M148.208,118.25   c-16.956,0-30.75,13.794-30.75,30.75c0,4.143-3.357,7.5-7.5,7.5s-7.5-3.357-7.5-7.5c0-25.227,20.523-45.75,45.75-45.75   c4.143,0,7.5,3.357,7.5,7.5S152.351,118.25,148.208,118.25z",
    style: {}
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "alert-siren-lights",
    d: "M148.625,50c4.143,0,7.5-3.357,7.5-7.5v-35c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v35   C141.125,46.643,144.482,50,148.625,50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "alert-siren-lights",
    d: "M89.819,60.445c1.39,2.406,3.91,3.751,6.502,3.751c1.272,0,2.563-0.324,3.743-1.006c3.587-2.071,4.816-6.658,2.745-10.245   l-17.5-30.311c-2.071-3.587-6.66-4.816-10.245-2.745c-3.587,2.071-4.816,6.658-2.745,10.245L89.819,60.445z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "alert-siren-lights",
    d: "M23.761,84.306l30.311,17.5c1.182,0.682,2.471,1.006,3.743,1.006c2.592,0,5.113-1.345,6.502-3.751   c2.071-3.587,0.842-8.174-2.745-10.245l-30.311-17.5c-3.59-2.07-8.175-0.843-10.245,2.745   C18.944,77.647,20.174,82.234,23.761,84.306z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "alert-siren-lights",
    d: "M198.186,63.19c1.182,0.682,2.471,1.006,3.743,1.006c2.592,0,5.113-1.345,6.502-3.751l17.5-30.311   c2.071-3.587,0.842-8.174-2.745-10.245c-3.589-2.071-8.176-0.843-10.245,2.745l-17.5,30.311   C193.369,56.532,194.599,61.119,198.186,63.19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "alert-siren-lights",
    d: "M240.436,102.812c1.272,0,2.563-0.324,3.743-1.006l30.311-17.5c3.587-2.071,4.816-6.658,2.745-10.245   c-2.072-3.588-6.66-4.815-10.245-2.745l-30.311,17.5c-3.587,2.071-4.816,6.658-2.745,10.245   C235.323,101.467,237.844,102.812,240.436,102.812z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSvgIcon);
export default __webpack_public_path__ + "static/media/ALERT_SVG_ICON.1e8b361a01f0b6a7e9b458b6835f9f0a.svg";
export { ForwardRef as ReactComponent };